import React, { useEffect, useState } from 'react'
import style from "./style/AboutMe.module.css"
import { useInView } from 'react-intersection-observer'

function AboutMe() {

    const [ref, inView] = useInView()
    const [styleTitle, setStyleTitle] = useState(style.info__h2)

    useEffect(()=> {
        if (inView) {
            setStyleTitle(style.info__h2Active)
        }else{
            setStyleTitle(style.info__h2)
        }
    })


    return (
        <div className={style.info}>
            <h2  id='aboutMe' ref={ref} className={styleTitle}>
                About me
            </h2>
            <p className={style.info__description}>
                Hello! I am engaged in web development and enthusiastically cultivate my skills in this field. My passion began in 2022 when I first tried my hand at web development. Subsequently, I decided to deepen my knowledge and enrolled in web programming courses offered by the Hillel computer school.
                The first course I completed was called "FrontEnd Basic," where I mastered HTML and CSS, including SCSS. I successfully completed this course with honors.
                Afterward, I delved into JavaScript. It was the "FrontEnd Pro" course, also conducted at Hillel school. Within the framework of this course, I immersed myself in the world of JS, learned GIT, and React.js. Currently, I am actively continuing to deepen my knowledge in JavaScript and React.js to strengthen my skills and achieve more in this exciting field
            </p>
            <ul className={style.info__list}>
                <li>
                    <span className={style.info__span}></span>
                    <p className={style.info__contact}>Full Name</p>
                    <a href="#" className={style.contact}>Hlushkov Pavlo</a>
                </li>
                <li>
                    <span className={style.info__span}></span>
                    <p className={style.info__contact}>Email Adress</p>
                    <a target='_blank' href="mailto:pavelgluskov264@gmail.com" className={style.contact}>pavelgluskov264@gmail.com</a>
                </li>
                <li>
                    <span className={style.info__span}></span>
                    <p className={style.info__contact}>Telegram</p>
                    <a target='_blank' href="https://t.me/P_Hlushkov" className={style.contact}>@P_Hlushkov</a>
                </li>
                <li>
                    <span className={style.info__span}></span>
                    <p className={style.info__contact}>Phone</p>
                    <a href="tel:+380505917397" className={style.contact}>+38 (050)59-17-397</a>
                </li>
            </ul>
        </div>
    )
}

export default AboutMe